// import productPicture1 from '@Theme/natucare/modules/V4/Products/files/kolagen-premium.png';
// import productPicture2 from '@Theme/natucare/modules/V4/Products/files/kolagen-premium.png';

const defaultItems = [];
const baseButton = {
  label: 'zobacz wszystkie produkty',
  href: '#'
};
const filterBy = keyword => defaultItems.filter(item => item.title.toLowerCase().includes(keyword));
const createFromQuery = query => {
  const lowered = (query || '').toLowerCase();
  if (!lowered) {
    return {
      items: defaultItems,
      button: baseButton
    };
  }
  if (lowered.includes('sleep')) {
    return {
      items: filterBy('sleep'),
      button: baseButton
    };
  }
  if (lowered.includes('kolagen')) {
    return {
      items: filterBy('kolagen'),
      button: baseButton
    };
  }
  return {
    items: [],
    button: baseButton
  };
};
export default {
  default: {
    items: defaultItems,
    button: baseButton
  },
  createFromQuery
};